import { ReactNode } from 'react';
import identity from 'lodash-es/identity';

import { GetTranslation } from 'common/i18n/types';
import { isUserLoggedInSelector } from 'users/selectors';

export type Section = {
  title: ReactNode;
  path: string;
};
export type Category = {
  title: string;
  icon: string;
  path?: string;
  sections: Section[];
};

export const addSections = (
  category: Category,
  sections: Section[],
): Category => ({
  ...category,
  sections: [...category.sections, ...sections],
});

export const createCategory = ({
  title,
  icon,
  path = undefined,
}: Omit<Category, 'sections'>): Category => ({
  title,
  icon,
  path,
  sections: [],
});
const freeAccess = () => null;

export const getStructure =
  <S>(routes, categories: Category[], t: GetTranslation = identity) =>
  (state: S): Category[] =>
    isUserLoggedInSelector(state as never)
      ? routes
          .filter(
            ({ redirect, pageConfig }) => !redirect && pageConfig.category,
          )
          .reduce(
            (result: Category[], route) => {
              const { checkAccess = freeAccess } = route;

              if (checkAccess(state)) {
                return result;
              }
              const categoryIndex = result.findIndex(
                ({ path }) => path === route.pageConfig.category,
              );

              if (categoryIndex > -1) {
                const category = result[categoryIndex];

                result.splice(
                  categoryIndex,
                  1,
                  addSections(category, [
                    { path: route.path, title: route.pageConfig.title },
                  ]),
                );
              }

              return result;
            },
            categories.map((category) => ({
              ...category,
              title: t(category.title),
            })),
          )
          .filter((category: Category) => category.sections.length > 0)
      : [];
